import { Agent, AgentAccessLevel, AgentScope } from "~/services/agents";

// Deleting an agent maps to the manager-only can_delete grant; SYSTEM agents are
// immutable. Distinct from editing (can_edit), which editors also hold.
export const useCanDeleteAgent = (agent: Agent | undefined): boolean =>
  !!agent && agent.scope !== AgentScope.SYSTEM && agent.access_level === AgentAccessLevel.MANAGER;
